import React,  { Fragment, useContext, useEffect, useState, useCallback, useMemo} from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { Footer } from '../../Component/Footer/Footer';
import { Header } from '../../Component/Header/Header';
import { Recommend } from '../../Component/Recommend/Recommend';
import { ARROW_STYLE, POINT_STYLE, Swiper } from '../../Component/Swiper/Swiper';
import { fetchData } from '../../Utils/fetch';
import { imageDomain, STYLE_TYPE } from '../../Utils/magicStrings'; 
import { Toptips } from '../Home/HomeStyle';
import { styleContextApp } from '../StyleContext';
import { ContentBlockWrapper,
     DetailTitle, DetailSubtitle,
      ContentPictureWrapper, ContentSubtitle, ContentMain, 
      DetailCatelogWrapper, DetailItems, ReserveButton,
      IntroText, ReseveIntroButton, ReserveText, ReserveIntroWrapper,
      TimeWrapper, TelephoneWrapper, TeleWrapper, IntroInfo, MapWrapper, MapIntro,
      ToReserveButton, ReturnButton, PlanButtonWrapper, OverviewWrapper
    } from './DetailStyle';
import topBig from '../Home/BigTop.png';
import topSmall from '../Home/SmallTop.png';
import { ReserveTeleWrapper, WechatWindow } from '../Reserve/ReserveStyle';
import { Modal } from '../../Component/Modal/Modal';
import wechat from '../Reserve/wechat.png';


export function Detail(props) {
    const { id } = useParams();
    const [ content, setContent ] = useState(null);
    const styleType = useContext(styleContextApp);
    const getContentInfo = useCallback( async (id) => {
        
        if(id) {
            try {
                const data = await fetchData(`inn/${id}`);
                setContent(data);
               
            } catch(e) {
                console.log(e);
            }
        } 
    }, []);
    
    useEffect(() => {
        
        getContentInfo(id)
 
        window.scrollTo(0,0);
    }, [getContentInfo, id]);


    const hasPlan = useMemo(() => {
        if(content) {
            return content.haveModelPlan ;
        } 
        return false;
    }, [content]);

    //
    if(!content) return null;
    return (
        <div>
            {
                hasPlan && 
                <Link to={`/plan/${id}`}>
                    <Toptips id='toptip' color={'#B69A67'} styleType={styleType}>
                        <span>{styleType === STYLE_TYPE.MOBILE ? ' 不知道怎麼玩？查看該旅舍的推薦行程' : '請點此查看旅行推薦行程'}</span>
                        <img id={'detail_link'} src={styleType === STYLE_TYPE.MOBILE ? topSmall : topBig}  alt=''/>
                    </Toptips>
                </Link>
            }
            <div className='before'>
                <Header hasMarginTop={content.haveModelPlan} title={`${content.title}-${content.name}`} styleType={styleType} pictures={[`${imageDomain}/${content.coverImgSmallUrl}`]} headerHeight={584} mobileHeight={404}/>
                <div style={{width: 'min(1440px, 100vw)', margin: 'auto'}}>
                <DetailTitle styleType={styleType}>
                    {content.name}
                </DetailTitle>
                <DetailSubtitle styleType={styleType}>
                    {content.title}
                </DetailSubtitle>
                <OverviewWrapper styleType={styleType}>{content.overview}</OverviewWrapper>
                <ContentPictureWrapper styleType={styleType} picType={1}>
                    <img src={`${imageDomain}/${content.coverImgUrl}`} alt='' className='lazyload'/>
                    ContentPictureWrapper                </ContentPictureWrapper>
                </div>
            </div>
            <div style={{width: 'min(1440px, 100vw)', margin: 'auto'}}>
            {content?.innSectionDtoList?.map((contentInfo, index) => (
                <ContentBlock contentInfo={contentInfo} key={contentInfo.id} index={index} styleType={styleType}/>
            ))}
            <DetailCatelog styleType={styleType} items={content.innSectionDtoList.map(e => e.title)}/>
            {styleType !== STYLE_TYPE.MOBILE && <ReserveButtonItem styleType={styleType} id={id} />}
            {<DetailBlock styleType={styleType} content={content} id={id}/>}
            <Recommend styleType={styleType} recommendItem={content.recommendList} />
            </div>
            <Footer styleType={styleType}></Footer>
        </div>
    );
};

const DetailBlock = ({styleType, content, id}) => {
    const priceFrom = useMemo(() => {
        return content?.innPlanList.reduce((prev, cur) => {
            return cur.priceFrom < prev?  cur.priceFrom : prev
        }, 1000000000);
    }, [content]);
    return (
        <Fragment>
            {content.position && <Map styleType={styleType} position={content.position.split(',')}></Map>}
            <ReserveIntro styleType={styleType}  text={priceFrom ? `每人每晚套餐價格${priceFrom}日元～起` : '優惠價格'} telephone={`預訂電話 ${content.phone}`} id={id} time={content.phoneMemo}/>
            {/* <IntroInfo styleType={styleType}>这是占位符这是占位符这是占位符这是占位符这是占位符这是占位符这是占位符这是占位符这是占位符这是占位符这是占位符这是占位符这是占位</IntroInfo> */}
        </Fragment>
    );
};

const PlanBlock = ({styleType, id}) => {
    return (
        <PlanButtonWrapper styleType={styleType}>
            <Link to={`/detail/${id}`}>
                <ReturnButton styleType={styleType}>返回詳情頁</ReturnButton>
            </Link>
            <Link to={`/reserve/${id}`}>
                <ToReserveButton styleType={styleType}>預訂此推薦行程</ToReserveButton>
            </Link>
        </PlanButtonWrapper>
    )
}

const ContentBlock = ({contentInfo, styleType, index}) => {
    const pictureElement = () => {
        const { imgUrlList, imgDisplayType }  = contentInfo; 
        if(!imgUrlList || !Array.isArray(imgUrlList) ||imgUrlList.length === 0 || imgDisplayType === 4) {
            return null;
        } else if (imgDisplayType === 1) {
            return (
                <ContentPictureWrapper styleType={styleType} picType={1}>
                    <img data-src={`${imageDomain}/${imgUrlList[0]}`} alt='' className='lazyload'/>
                </ContentPictureWrapper>
            );
        } else if (imgDisplayType === 2) {
            return (
                <ContentPictureWrapper styleType={styleType} picType={4}>
                    {imgUrlList.map((pic, i) => (
                        <div key={i}>
                            <img data-src={`${imageDomain}/${pic}`} alt='' className='lazyload' />
                        </div>
                    ))}
                </ContentPictureWrapper>
            );
        } else {
            const picElement = imgUrlList.map(pic => (
                <img data-src={`${imageDomain}/${pic}`} key={pic} alt='' className='lazyload' style={{width: '100%', height: '100%'}} />
            ));
            return (
                <ContentPictureWrapper styleType={styleType} picType={5}>
                    {
                        <Swiper 
                            height={styleType === STYLE_TYPE.MOBILE ? 210 : 411} 
                            isAutoPlay={false} 
                            pointStyle={styleType === STYLE_TYPE.MOBILE ? POINT_STYLE.NONE :POINT_STYLE.POINT_2} 
                            arrowStyle={styleType === STYLE_TYPE.MOBILE ? ARROW_STYLE.WHITE_CIRCLE_3 :ARROW_STYLE.BIG_CIRCLE_2}  
                            elements={picElement} 
                            isLoop={true} 
                            hasArrow={false}
                        />
                    }
                </ContentPictureWrapper>
            ) ;
        }
    };

    return (
        <ContentBlockWrapper  styleType={styleType} className='content_block' id={`content_${index}`}>
            <ContentSubtitle styleType={styleType}>
                {contentInfo.title}
            </ContentSubtitle>
            <ContentMain styleType={styleType}>
                {contentInfo.content}
            </ContentMain>
            {pictureElement()}
        </ContentBlockWrapper>
    )
};

const DetailCatelog = ({items, styleType}) => {
    const [ nowPostion, setNowPosition ] = useState(0);
    const [ fixContent, setFixContent ] = useState(false);
    const [ hide, setHide ] = useState(false);
    const { id } = useParams();
    useEffect(() => {
        var intersectionObserver = new IntersectionObserver(function(entries) {
            // If intersectionRatio is 0, the target is out of view
            // and we do not need to do anything.
            if (entries[0].intersectionRatio <= 0) setHide(false);
            else setHide(true);
          });
          // start observing
          const element = document.querySelector('#footer');
          element && intersectionObserver.observe(element);
          return () => {
            element && intersectionObserver.unobserve(element);
          }
    }, []);
    
    useEffect(() => {
        if(!items) return;
        const allBlock = document.getElementsByClassName('content_block');
        let position =  document.getElementsByClassName('before')[0].getBoundingClientRect().height;

        const blockPosition = Array.from(allBlock).map((now, index) => {
            let last = position;
            position += now.getBoundingClientRect().height;
            return last;
        });

        const scrollListen = (e) => {
            let scrollTop = document.documentElement.scrollTop;
            //计算头图的高度.
            setFixContent(scrollTop > document.getElementById('header')?.offsetHeight);
            for(let i = 0; i < blockPosition.length; i++) {
                if(scrollTop < blockPosition[i]) {setNowPosition(i-1);break;}
            }
        }
        scrollListen();
        document.addEventListener('scroll', scrollListen);
        return () => {
            document.removeEventListener('scroll', scrollListen);
        }
    }, [items]);
    if(hide) return null;
    const length = styleType === STYLE_TYPE.MOBILE ? 5 : 10;
    return(
        <DetailCatelogWrapper styleType={styleType} needFixed={fixContent}>
            {items.map((item, index) => (
                <DetailItems href={`#content_${index}`} key={index} styleType={styleType} id={index} highlight={index === nowPostion} onClick={() => {
                    
                    setNowPosition(index);                 
                      //document.documentElement.scrollTop = document.getElementById(`content_${index}`).getBoundingClientRect().y + window.scrollY;
                }}>{item.substring(0,length)}</DetailItems>
            ))}
            {styleType === STYLE_TYPE.MOBILE && <ReserveButtonItem styleType={styleType} id={id} />}
        </DetailCatelogWrapper>
    )
};

const ReserveButtonItem = ({styleType, id}) => {
    const [ hide, setHide ] = useState(false);
    useEffect(() => {
        if(styleType !== STYLE_TYPE.MOBILE) {
            var intersectionObserver = new IntersectionObserver(function(entries) {
                // If intersectionRatio is 0, the target is out of view
                // and we do not need to do anything.
                if (entries[0].intersectionRatio <= 0) setHide(false);
                else setHide(true);
              });
              const element = document.querySelector('#recommend');
              element && intersectionObserver.observe(element);
              // start observing
              return () => {
                element && intersectionObserver.unobserve(element);
              }
        }
    }, [styleType]);
    if(hide) return null;
    return (
        <Link to={`/reserve/${id}`}>
            <ReserveButton styleType={styleType}>{styleType === STYLE_TYPE.MOBILE ? '現在預訂' : '咨詢・預約'}</ReserveButton>
        </Link>
    )
}

const ReserveIntro = ({text, styleType, telephone, time, id}) => {
    const [showWechat, setShowWechat] = useState(false);
    const toShowWechat = () => {
        setShowWechat(true);
    }
    const wechatElement = useMemo(() => {
        return (
            <WechatWindow styleType={styleType} setShowMenu={setShowWechat} >
                <img src={wechat} alt=''></img>
            </WechatWindow>
        )
    }, [styleType]);
    return (
        <Fragment>
            <ReserveIntroWrapper styleType={styleType} id={'intro'}>
            <ReserveText styleType={styleType}>{text}</ReserveText>
            <Link to={`/reserve/${id}`}>
                <ReseveIntroButton styleType={styleType}>咨詢・預約</ReseveIntroButton>
            </Link>
            {/* <IntroText styleType={styleType}>以最優價格為您預定</IntroText> */}
            
        </ReserveIntroWrapper>
            <ReserveTeleWrapper styleType={styleType} isDetail={true}>
                <span>如有疑問請諮詢</span>
                <a href='https://www.facebook.com/megurutraveljp/'>FB</a>
                <span>或是</span>
                <span onClick={toShowWechat} style={{color: 'rgb(85, 26, 139)',
                cursor: 'pointer'}}>微信</span>
            </ReserveTeleWrapper>
            {showWechat && <Modal positionType={'middle'} modalElement={wechatElement} setModalOpen={setShowWechat} backdropClose={true}/>}
        </Fragment>

    )
};

const Map = ({styleType, position}) => {
    useEffect(() => {
        var script = document.createElement("script"); 
        script.src = "https://api.map.baidu.com/api?v=1.0&type=webgl&ak=8SB6Z4T1OfKqw3LgUGF1zHHeK2YDGBnT&callback=mapCallback";
        document.body.appendChild(script); 

        window.mapCallback = function() {
            var map = new window.BMapGL.Map("map_container");
            // 创建地图实例 
            var point = new window.BMapGL.Point(position[1], position[0]);  
            // 创建点坐标 
            map.centerAndZoom(point, 12);
            map.enableScrollWheelZoom(true); 
            var marker = new window.BMapGL.Marker(point);        // 创建标注   
            map.addOverlay(marker);                     // 将标注添加到地图中
        }

        return () => {
            window.mapCallback = null;
        }
    }, [position]);

    return(
        <MapWrapper styleType={styleType}>
            <MapIntro styleType={styleType}><span>旅舍地址</span></MapIntro>
            <div id='map_container'></div>
        </MapWrapper>
    )
}
